import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "content"]

  connect() {
    this.showContent(0); // Default to showing the first category on load
  }

  selectCategory(event) {
    const index = parseInt(event.currentTarget.dataset.index);
    this.showContent(index);
  }

  showContent(selectedIndex) {
    this.tabTargets.forEach((tab, index) => {
      const isActive = index === selectedIndex;
      tab.classList.toggle("border-blue-500", isActive);
      tab.classList.toggle("border-transparent", !isActive);
      tab.classList.toggle("text-blue-600", isActive);
      tab.classList.toggle("text-gray-600", !isActive);
    });

    this.contentTargets.forEach((content, index) => {
      content.classList.toggle("hidden", index !== selectedIndex);
    });
  }
}
